import { ActionContext, Module } from 'vuex'
import { RootState, TeamState } from './state_models'

import Team from '../models/team'
import sortBy from "lodash-es/sortBy"

export const teams: Module<TeamState, RootState> = {
  namespaced: true,
  state: { teams: [], locationId: undefined },
  getters: {
    getById: (state: TeamState) => {
      return (id: string) => state.teams.find(x => x.id === id)
    },
    calendarProviders(state: TeamState) {
      return state.teams.filter(x => x.slug) //
    }
  },
  mutations: {
    set: (
      state: TeamState,
      payload: { teams: any[]; locationId: string }
    ) => {
      state.teams = payload.teams
      if (payload.locationId) {
        state.locationId = payload.locationId
      }
    },
    clearAll(state: TeamState) {
      state.teams = []
      state.locationId = undefined
    }
  },
  actions: {
    /**
     * This function mainly created for making sure we'll get the promise in any way to make sure we'll get the data before we start using location and team.
     * @param context
     * @param locationId
     * @returns boolean
     */
    async hasAnyCalendarProviders(
      context: ActionContext<TeamState, RootState>, locationId: string
    ){
        return new Promise(async(resolve) => {
          if (!locationId) {
            resolve(false)
          }
          // Let's match the received location id with state location id
          if (context.state.locationId === locationId) {
            resolve(context.state.teams.length > 0)
          }
          // Seems like we don't have any data in state so let's fetch it and store it in state
          const snapshot = Team.fetchAllByLocation(locationId).get()
          snapshot.then(data => {
            const teams = data.docs.map(d => ({ id: d.id, ...d.data() }))
            const sortedTeam = sortBy(teams, (t) => t.calendar_provider_name ? t.calendar_provider_name.toUpperCase() : '')
            context.commit('set', {
              locationId: locationId,
              teams: sortedTeam
            })
             resolve(sortedTeam.length>0)
          }).catch(() =>{
            resolve(context.state.teams.length > 0)
          })
        });
    },
    async syncAll(
      context: ActionContext<TeamState, RootState>,
      options: string | {locationId:string,force:boolean},
    ) {
      let force = false
      let locationId = options
      if(typeof options === 'object')
      {
        locationId = options.locationId
        force = options.force
      }
      if (!locationId) {
        return
      }

      if (context.state.locationId === locationId && !force) {
        return context.state.teams
      }

      context.commit('clearAll')

      return new Promise((resolve, reject) => {
        Team.fetchAllByLocation(locationId as string).get()
          .then(snapshot => {
            const teams = snapshot.docs.map(d => ({ id: d.id, ...d.data() }))
            const sortedTeam = sortBy(teams, (t) => t.calendar_provider_name ? t.calendar_provider_name.toUpperCase() : '')

            context.commit('set', {
              locationId: locationId,
              teams: sortedTeam
            })

            resolve(context.state.teams)
          })
          .catch(err => {
            console.error(err)
            reject(err)
          })
      })
    },
    logout: {
      root: true,
      handler: (context: ActionContext<TeamState, RootState>) => {
        context.commit('clearAll')
      }
    },
    clearAll: {
      handler: (context: ActionContext<TeamState, RootState>) => {
        context.commit('clearAll')
      }
    }
  }
}
